import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {getImageAssetUrl} from '@/_application/core/utils/common';

const FacebookIcon = getImageAssetUrl('icons/facebook.svg');
const TiktokIcon = getImageAssetUrl('icons/tiktok.svg');
const YoutubeIcon = getImageAssetUrl('icons/youtube.svg');

interface SocialMediaLink {
    href: string;
    icon: string;
    alt: string;
    followers: string;
    followersLabel: string;
}

const SOCIAL_MEDIA_LINKS: SocialMediaLink[] = [
    {
        href: 'https://www.facebook.com/kidsplaza.com.vn',
        icon: FacebookIcon,
        alt: 'Facebook',
        followers: '1,2M',
        followersLabel: 'Followers',
    },
    {
        href: 'https://www.youtube.com/user/KidsPlazaChannel?sub_confirmation=1',
        icon: YoutubeIcon,
        alt: 'Youtube',
        followers: '23,5k',
        followersLabel: 'Subscribers',
    },
    {
        href: 'https://www.tiktok.com/@kidsplazaofficial',
        icon: TiktokIcon,
        alt: 'Tiktok',
        followers: '93K',
        followersLabel: 'Followers',
    },
];

const SocialNetwork = () => {
    return (
        <div className="flex items-center justify-center gap-5">
            {SOCIAL_MEDIA_LINKS.map(link => (
                <Link
                    key={link.alt}
                    href={link.href}
                    className="flex flex-col items-center gap-0.5 transition-opacity hover:opacity-80">
                    <Image src={link.icon} alt={link.alt} width={32} height={32} />

                    <p className="flex flex-col items-center text-[10px] leading-[13px] text-black">
                        <span className="font-bold">{link.followers}</span>
                        <span>{link.followersLabel}</span>
                    </p>
                </Link>
            ))}
        </div>
    );
};

export default SocialNetwork;
